import * as React from 'react';

import { useLocation } from 'js/lib/useRouter';

import EnterpriseAutoEnrolledCoursesDataProvider from 'bundles/unified-common/providers/EnterpriseAutoEnrolledCoursesDataProvider';
import EnterpriseCareerAcademyVariantDataProvider from 'bundles/unified-common/providers/EnterpriseCareerAcademyVariantDataProvider';
import EnterpriseModalManagerProvider from 'bundles/unified-common/providers/EnterpriseModalManagerProvider';
import EnterpriseProductFeaturesDataProvider from 'bundles/unified-common/providers/EnterpriseProductFeaturesDataProvider';
import EnterpriseProgramDataProvider from 'bundles/unified-common/providers/EnterpriseProgramDataProvider';
import EnterpriseAdminEnrollmentDataProvider from 'bundles/unified-description-page-common/providers/enterprise/EnterpriseAdminEnrollmentDataProvider';
import EnterpriseAvailableEnrollmentProgramsDataProvider from 'bundles/unified-description-page-common/providers/enterprise/EnterpriseAvailableEnrollmentProgramsDataProvider';

const EnterpriseDescriptionPageDataProvider = ({ children }: { children: React.ReactNode }) => {
  const { query } = useLocation();
  const isExternal = query.isExternal === 'true';
  return (
    <EnterpriseProgramDataProvider>
      <EnterpriseProductFeaturesDataProvider>
        <EnterpriseAutoEnrolledCoursesDataProvider ssr={isExternal}>
          <EnterpriseCareerAcademyVariantDataProvider>
            <EnterpriseAvailableEnrollmentProgramsDataProvider>
              <EnterpriseAdminEnrollmentDataProvider>
                <EnterpriseModalManagerProvider>{children}</EnterpriseModalManagerProvider>
              </EnterpriseAdminEnrollmentDataProvider>
            </EnterpriseAvailableEnrollmentProgramsDataProvider>
          </EnterpriseCareerAcademyVariantDataProvider>
        </EnterpriseAutoEnrolledCoursesDataProvider>
      </EnterpriseProductFeaturesDataProvider>
    </EnterpriseProgramDataProvider>
  );
};

export default EnterpriseDescriptionPageDataProvider;
